import { yandexAutorization } from "@src/entities/login/api/requests/yandexAutorization";
import { LOGIN_QUERY_KEYS } from "../../constants";
import { useQuery } from "@tanstack/react-query";

export const useYandexAutorization = () => {
  const query = useQuery({
    queryKey: [LOGIN_QUERY_KEYS.yandexAutorization],
    queryFn: () => yandexAutorization(),
    enabled: false,
  });

  return query;
};
